/* Demo gratuit, în două feluri, alese de vizitator:
     · restaurare / colorare: o fotografie veche;
     · adăugare persoană: fotografia principală + o fotografie cu persoana de adăugat.
   Serverul întoarce DOAR varianta cu filigran. După rezultat, un singur drum: pachetul potrivit felului de demo,
   cu fotografiile deja puse în comandă. */
(function () {
  'use strict';

  var STORE_KEY = 'rf_demo_v1';
  var PENDING_KEY = 'rf_demo_pending_v1';

  /* Numere de mobil din România (07xx xxx xxx) sau, cu prefix, din orice țară. La fel ca în configurator. */
  function normalizePhone(value) {
    var d = String(value || '').replace(/[\s\-().\/]/g, '');
    if (/^00\d/.test(d)) d = '+' + d.slice(2);
    if (/^07\d{8}$/.test(d)) return '+4' + d;
    if (/^7\d{8}$/.test(d)) return '+40' + d;
    if (/^407\d{8}$/.test(d)) return '+' + d;
    if (/^\+407\d{8}$/.test(d)) return d;
    if (/^\+40/.test(d)) return null;
    if (/^\+[1-9]\d{7,14}$/.test(d)) return d;
    return null;
  }

  function init(box) {
    if (box.hasAttribute('data-rf-bound')) return;
    box.setAttribute('data-rf-bound', '');

    var states = box.querySelectorAll('[data-rf-demo-state]');
    var input = box.querySelector('[data-rf-demo-input]');
    var colorBox = box.querySelector('[data-rf-demo-color]');
    var preview = box.querySelector('[data-rf-demo-preview]');
    var status = box.querySelector('[data-rf-demo-status]');
    var result = box.querySelector('[data-rf-demo-result]');
    var buy = box.querySelector('[data-rf-demo-buy]');
    var again = box.querySelector('[data-rf-demo-again]');
    var errorText = box.querySelector('[data-rf-demo-error]');
    var defaultError = errorText ? errorText.textContent : '';
    var ticker = 0, current = null;

    /* ---- felul de demo ---- */
    var kind = 'restore';
    var kindTabs = box.querySelectorAll('[data-rf-demo-kind]');
    var kindPanes = box.querySelectorAll('[data-rf-demo-pane]');
    function setKind(next, quiet) {
      kind = next === 'person' ? 'person' : 'restore';
      kindTabs.forEach(function (tab) {
        var on = tab.getAttribute('data-rf-demo-kind') === kind;
        tab.classList.toggle('is-on', on);
        tab.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      kindPanes.forEach(function (pane) { pane.hidden = pane.getAttribute('data-rf-demo-pane') !== kind; });
      if (!quiet) RF.log('demo_kind', { kind: kind });
    }
    kindTabs.forEach(function (tab) { tab.addEventListener('click', function () { setKind(tab.getAttribute('data-rf-demo-kind')); }); });

    function messagesFor(k) {
      return (box.getAttribute(k === 'person' ? 'data-t-processing-person' : 'data-t-processing') || '').split('|').filter(Boolean);
    }
    function show(name, k) {
      states.forEach(function (s) { s.hidden = s.getAttribute('data-rf-demo-state') !== name; });
      clearInterval(ticker);
      var messages = messagesFor(k || kind);
      if (name === 'working' && messages.length) {
        var i = 0;
        status.textContent = messages[0];
        if (messages.length > 1) ticker = setInterval(function () { i = (i + 1) % messages.length; status.textContent = messages[i]; }, 3200);
      }
    }

    function showResult(demo) {
      current = demo;
      var person = demo.kind === 'person';
      var before = box.getAttribute('data-t-before') || 'Înainte';
      var after = box.getAttribute('data-t-after') || 'După';
      result.innerHTML =
        '<div class="rf-compare" data-rf-compare style="--rf-ar: ' + demo.width + ' / ' + demo.height + '; --rf-pos: 50%;">' +
        '<div class="rf-compare__layer rf-compare__layer--after"><img alt=""></div>' +
        '<div class="rf-compare__layer rf-compare__layer--before"><img alt=""></div>' +
        '<span class="rf-compare__label rf-compare__label--before"></span><span class="rf-compare__label rf-compare__label--after"></span>' +
        '<div class="rf-compare__handle" aria-hidden="true"><span class="rf-compare__knob"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l-5 6 5 6M15 6l5 6-5 6"/></svg></span></div>' +
        '<input class="rf-compare__range" type="range" min="0" max="100" value="50" aria-label="' + before + ' / ' + after + '"></div>';
      var imgs = result.querySelectorAll('img'), labels = result.querySelectorAll('.rf-compare__label');
      imgs[0].src = demo.after; imgs[1].src = demo.before;
      labels[0].textContent = before; labels[1].textContent = after;
      RF.compare.init(result.querySelector('[data-rf-compare]'));
      if (again) again.hidden = !(demo.remaining > 0);
      // textele butonului și ce apare sub el depind de felul demo-ului
      box.querySelectorAll('[data-rf-demo-for]').forEach(function (el) { el.hidden = el.getAttribute('data-rf-demo-for') !== (person ? 'person' : 'restore'); });
      var leadWrap = box.querySelector('[data-rf-demo-lead-wrap]');
      if (leadWrap) {
        leadWrap.hidden = person;                              // demo-ul pe WhatsApp există doar la restaurare
        var form = box.querySelector('[data-rf-demo-lead-form]'), open = box.querySelector('[data-rf-demo-lead-open]'), ok = box.querySelector('[data-rf-demo-lead-ok]');
        if (form) form.hidden = true;
        if (open) open.hidden = false;
        if (ok) ok.hidden = true;
      }
      show('done');
      shownAt = Date.now(); leftSent = false;
      RF.log('demo_result_shown', { demo: demo.id, kind: demo.kind || 'restore' });
    }

    // cât a stat omul cu rezultatul în față, măsurat când pleacă din pagină sau o ascunde (o singură dată pe rezultat)
    var shownAt = 0, leftSent = false;
    function leaving() {
      if (!shownAt || leftSent || !current) return;
      leftSent = true;
      RF.log('demo_result_left', { demo: current.id, sec: Math.round((Date.now() - shownAt) / 1000) });
    }
    window.addEventListener('pagehide', leaving);
    document.addEventListener('visibilitychange', function () { if (document.hidden) leaving(); });

    function fail(err) {
      if (err && (err.status === 429 || err.code === 'limit')) return show('limit');
      if (errorText) {
        errorText.textContent = err && err.message === 'decode' ? (box.getAttribute('data-t-decode') || defaultError)
          : err && err.code === 'no-api' ? (box.getAttribute('data-t-noapi') || defaultError)
          : defaultError;
      }
      show('error');
    }

    // Generarea durează cam un minut. Pagina nu ține o legătură deschisă atâta timp (pe telefon se rupe ușor):
    // trimite fotografia, primește un număr și întreabă din când în când dacă e gata. Numărul se ține minte,
    // așa că rezultatul apare și dacă omul pleacă din pagină și revine.
    var POLL_MS = 3000, GIVE_UP_MS = 6 * 60 * 1000, pollTimer = 0;

    function finish(res, pending) {
      RF.store.del(PENDING_KEY);
      var demo = { id: res.id, kind: res.kind || pending.kind || 'restore', after: res.url, before: res.before || pending.before, thumb: pending.thumb, personThumb: pending.personThumb,
                   width: res.width || pending.width, height: res.height || pending.height, remaining: res.remaining, expires: res.expires, color: pending.color };
      RF.store.set(STORE_KEY, demo);
      RF.track('demo_generated', { remaining: res.remaining, kind: demo.kind });
      showResult(demo);
    }

    function poll(pending) {
      clearTimeout(pollTimer);
      if (Date.now() - pending.started > GIVE_UP_MS) { RF.store.del(PENDING_KEY); return fail(new Error('timeout')); }
      RF.api('/api/demo/' + pending.id, { headers: { 'X-Visitor': RF.uid() } }).then(function (res) {
        if (res.status === 'done') return finish(res, pending);
        if (res.status === 'failed') { RF.store.del(PENDING_KEY); return fail(new Error('failed')); }
        pollTimer = setTimeout(function () { poll(pending); }, POLL_MS);
      }).catch(function () {                                  // fără internet o clipă: mai încercăm
        pollTimer = setTimeout(function () { poll(pending); }, POLL_MS);
      });
    }

    function started(res, pending, canvas) {
      pending.id = res.id;
      if (res.status !== 'working') { pending.before = RF.thumb(canvas, 1200); return finish(res, pending); }   // server mai vechi: a răspuns direct
      RF.store.set(PENDING_KEY, pending);
      poll(pending);
    }

    /* ---- restaurare / colorare: o fotografie ---- */
    function run(file) {
      var colour = !colorBox || colorBox.checked;            // fără bifă în temă: color, ca până acum
      RF.track('demo_upload', { color: colour, kind: 'restore' });
      RF.shrinkImage(file, 2000, 0.9).then(function (img) {
        preview.src = RF.thumb(img.canvas, 600);
        show('working', 'restore');
        var pending = { kind: 'restore', started: Date.now(), color: colour, thumb: RF.thumb(img.canvas, 420), preview: preview.src, width: img.width, height: img.height };
        return RF.api('/api/demo?async=1' + (colour ? '' : '&color=0'), {
          method: 'POST',
          headers: { 'Content-Type': 'image/jpeg', 'X-Visitor': RF.uid() },
          body: img.blob
        }).then(function (res) { started(res, pending, img.canvas); });
      }).catch(fail);
    }

    input.addEventListener('change', function () {
      if (input.files && input.files[0]) run(input.files[0]);
      input.value = '';
    });
    var drop = input.closest('.rf-drop');
    if (drop) {
      drop.addEventListener('dragover', function (e) { e.preventDefault(); drop.classList.add('is-over'); });
      drop.addEventListener('dragleave', function () { drop.classList.remove('is-over'); });
      drop.addEventListener('drop', function (e) {
        e.preventDefault(); drop.classList.remove('is-over');
        var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (file) run(file);
      });
    }

    /* ---- adăugare persoană: două fotografii, apoi butonul de pornire ---- */
    var chosen = { main: null, person: null };
    var go = box.querySelector('[data-rf-demo-go]');
    var goMsg = box.querySelector('[data-rf-demo-go-msg]');
    function refreshGo() { if (go) go.disabled = !(chosen.main && chosen.person); if (goMsg) goMsg.hidden = true; }
    box.querySelectorAll('[data-rf-demo-pick]').forEach(function (field) {
      var which = field.getAttribute('data-rf-demo-pick');
      var slot = field.closest('.rf-drop');
      field.addEventListener('change', function () {
        var file = field.files && field.files[0];
        field.value = '';
        if (!file) return;
        RF.shrinkImage(file, 2000, 0.9).then(function (img) {
          chosen[which] = img;
          var thumb = slot.querySelector('[data-rf-demo-pick-thumb]');
          if (thumb) { thumb.src = RF.thumb(img.canvas, 300); thumb.hidden = false; }
          slot.classList.add('is-filled');
          RF.log('demo_person_pick', { which: which });
          refreshGo();
        }).catch(function () { if (goMsg) { goMsg.textContent = box.getAttribute('data-t-decode') || defaultError; goMsg.hidden = false; } });
      });
    });
    function dataUrl(blob) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () { resolve(String(reader.result)); };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    }
    if (go) go.addEventListener('click', function () {
      if (!chosen.main || !chosen.person) { if (goMsg) { goMsg.textContent = box.getAttribute('data-t-need-both') || ''; goMsg.hidden = false; } return; }
      var main = chosen.main, person = chosen.person;
      RF.track('demo_upload', { kind: 'person' });
      preview.src = RF.thumb(main.canvas, 600);
      show('working', 'person');
      var pending = { kind: 'person', started: Date.now(), color: true, thumb: RF.thumb(main.canvas, 420), personThumb: RF.thumb(person.canvas, 420),
                      preview: preview.src, width: main.width, height: main.height };
      Promise.all([dataUrl(main.blob), dataUrl(person.blob)]).then(function (urls) {
        return RF.api('/api/demo/person?async=1', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Visitor': RF.uid() },
          body: JSON.stringify({ main: urls[0], person: urls[1] })
        });
      }).then(function (res) { started(res, pending, main.canvas); }).catch(fail);
    });
    refreshGo();

    /* ---- după rezultat: un singur drum, spre pachetul potrivit ---- */
    if (buy) buy.addEventListener('click', function (e) {
      e.preventDefault();
      var k = current && current.kind === 'person' ? 'person' : 'restore';
      RF.track('demo_buy_click', { kind: k });
      if (current) document.dispatchEvent(new CustomEvent('rf:demo-buy', { detail: { id: current.id, kind: k, thumb: current.thumb, personThumb: current.personThumb, color: current.color !== false } }));
      RF.scrollTo(document.querySelector(buy.getAttribute('href')));
    });
    if (again) again.addEventListener('click', function () { RF.log('demo_again', {}); show('idle'); });

    /* „Mă mai gândesc: trimite-mi demo-ul pe WhatsApp” (doar la restaurare): numărul se cere abia după apăsare. */
    var leadOpen = box.querySelector('[data-rf-demo-lead-open]');
    var leadForm = box.querySelector('[data-rf-demo-lead-form]');
    if (leadOpen && leadForm) (function () {
      var phoneInput = leadForm.querySelector('[data-rf-demo-phone]');
      var send = leadForm.querySelector('[data-rf-demo-lead]');
      var msg = leadForm.querySelector('[data-rf-demo-lead-msg]');
      var ok = box.querySelector('[data-rf-demo-lead-ok]');
      function say(text) { msg.textContent = text || ''; msg.hidden = !text; }
      leadOpen.addEventListener('click', function () {
        RF.log('demo_lead_open', {});
        leadOpen.hidden = true; leadForm.hidden = false; phoneInput.focus();
      });
      phoneInput.addEventListener('input', function () { say(''); });
      send.addEventListener('click', function () {
        if (!current) return;
        var phone = normalizePhone(phoneInput.value);
        if (!phone) { RF.log('demo_lead_nophone', { typed: phoneInput.value.length }); say(box.getAttribute('data-t-need-phone')); phoneInput.focus(); return; }
        send.disabled = true; say('');
        RF.api('/api/demo/' + current.id + '/lead', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Visitor': RF.uid() }, body: JSON.stringify({ phone: phone })
        }).then(function () {
          RF.track('demo_lead', {});
          leadForm.hidden = true; send.disabled = false;
          if (ok) ok.hidden = false;
        }).catch(function (err) {
          send.disabled = false;
          RF.log('demo_lead_failed', { why: String(err && (err.code || err.message) || '').slice(0, 40) });
          say(box.getAttribute('data-t-failed'));
        });
      });
    })();

    var retry = box.querySelector('[data-rf-demo-retry]');
    if (retry) retry.addEventListener('click', function () { show('idle'); });

    // rezultatul rămâne pe pagină dacă omul revine, cât timp adresa semnată e valabilă
    var saved = RF.store.get(STORE_KEY, null);
    if (saved && saved.expires && saved.expires > Date.now() + 60000) { setKind(saved.kind, true); showResult(saved); }
    else if (saved) RF.store.del(STORE_KEY);

    // o generare începută înainte ca omul să plece din pagină: o reluăm de unde a rămas
    var pending = RF.store.get(PENDING_KEY, null);
    if (pending && pending.id && Date.now() - pending.started < GIVE_UP_MS) {
      if (pending.preview) preview.src = pending.preview;
      setKind(pending.kind, true);
      show('working', pending.kind);
      poll(pending);
    } else if (pending) RF.store.del(PENDING_KEY);
    // revenit în pagină după ce telefonul a fost blocat: întrebăm pe loc, nu la următorul tic
    document.addEventListener('visibilitychange', function () {
      var p = RF.store.get(PENDING_KEY, null);
      if (!document.hidden && p && p.id) poll(p);
    });
  }

  RF.register(function (root) { root.querySelectorAll('[data-rf-demo]').forEach(init); });
})();
